import apiClient from '../apiClient';
import { GET_INVOICE_STATUS_PAYMENT_GATEWAY_URL } from '../apiUrl';

const getInvoiceStatusUsingPaymentGatewayApi = Id => {
  return apiClient.get(GET_INVOICE_STATUS_PAYMENT_GATEWAY_URL(Id));
};

export default getInvoiceStatusUsingPaymentGatewayApi;
